import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIChatService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import { isPC, isWeChat, isUniFrameWork } from "../../../../utils/env";
import { TUIGlobal } from "../../../../utils/universal-api/index";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import videoIcon from "../../../../assets/icon/video.png";
import videoUniIcon from "../../../../assets/icon/video-uni.png";
import cameraUniIcon from "../../../../assets/icon/camera-uni.png";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 视频源, 仅uniapp版本有效, web版本仅支持从文件中选择视频
    // album: 从文件中选择
    // camera: 使用相机拍摄
    videoSourceType: {
      type: String,
      "default": "album"
    }
  },
  emits: ["close"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var inputRef = ref();
    var _currentConversation = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var handleIcon = function handleIcon() {
      if (isUniFrameWork) {
        switch (props.videoSourceType) {
          case "album":
            return videoUniIcon;
          case "camera":
            return cameraUniIcon;
          default:
            return videoUniIcon;
        }
      } else {
        return videoIcon;
      }
    };
    var handleTitle = function handleTitle() {
      if (isUniFrameWork && props.videoSourceType === "camera") {
        return "录制";
      } else {
        return "视频";
      }
    };
    var onIconClick = function onIconClick() {
      // uniapp环境发送视频
      if (isUniFrameWork) {
        // 增加 TUIGlobal.chooseMedia 条件限制，防御 uni 打包其他平台小程序时由于打包问题导致 isWeChat 为 true 出现运行时报错
        if (isWeChat && TUIGlobal !== null && TUIGlobal !== void 0 && TUIGlobal.chooseMedia) {
          // 微信小程序从基础库 2.21.0 开始， wx.chooseVideo 停止维护，请使用 uni.chooseMedia 代替
          TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.chooseMedia({
            mediaType: ["video"],
            count: 1,
            sourceType: [props.videoSourceType],
            maxDuration: 60,
            success: function success(res) {
              sendVideoMessage(res);
            }
          });
        } else {
          // uniapp h5/app 发送图片
          TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.chooseVideo({
            count: 1,
            sourceType: [props.videoSourceType],
            success: function success(res) {
              sendVideoMessage(res);
            }
          });
        }
      } else {
        var _inputRef$value, _inputRef$value2;
        (inputRef === null || inputRef === void 0 || (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 ? void 0 : _inputRef$value.click) && (inputRef === null || inputRef === void 0 || (_inputRef$value2 = inputRef.value) === null || _inputRef$value2 === void 0 ? void 0 : _inputRef$value2.click());
      }
    };
    var sendVideoInWeb = function sendVideoInWeb(e) {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.files) === null || _e$target === void 0 ? void 0 : _e$target.length) <= 0) {
        return;
      }
      sendVideoMessage(e === null || e === void 0 ? void 0 : e.target);
      e.target.value = "";
    };
    var sendVideoMessage = function sendVideoMessage(file) {
      var _currentConversation$, _currentConversation$2, _currentConversation$3;
      if (!file) {
        return;
      }
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          file: file
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      TUIChatService.sendVideoMessage(options);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: handleIcon(),
        title: handleTitle(),
        needDialog: false,
        iconWidth: _unref(isUniFrameWork) ? '32px' : '21px',
        iconHeight: _unref(isUniFrameWork) ? props.videoSourceType === 'album' ? '20px' : '25px' : '18px',
        onOnIconClick: onIconClick
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass(['video-upload', !_unref(isPC) && 'video-upload-h5'])
          }, [_createElementVNode("input", {
            title: "视频",
            type: "file",
            "data-type": "video",
            accept: "video/*",
            onChange: sendVideoInWeb,
            ref_key: "inputRef",
            ref: inputRef
          }, null, 544)], 2)];
        }),
        _: 1
      }, 8, ["iconFile", "title", "iconWidth", "iconHeight"]);
    };
  }
});